module.exports = __webpack_public_path__ + "img/star.8cf50c07.png";